/* PELOFF · offre en paliers : ajoute N gants (+ le cadeau) au tiroir panier Shrine ; la remise automatique du palier s'applique au panier. */
class PlfOffre extends HTMLElement {
  connectedCallback() {
    this.Q = (this.dataset.q || '').split('|').map(Number);
    this.cartes = [...this.querySelectorAll('.pof__c')];
    this.btn = this.querySelector('.pof__btn'); this.err = this.querySelector('.pof__err');
    this.addEventListener('change', () => this.cartes.forEach((c) => c.classList.toggle('is-on', c.querySelector('input').checked)));
    this.btn.addEventListener('click', () => this.ajouter());
  }
  get carte() { return this.cartes.find((x) => x.querySelector('input').checked) || this.cartes[0]; }
  get i() { return +this.carte.dataset.i; }
  async ajouter() {
    this.btn.classList.add('is-load');
    try {
      const items = [{ id: +this.dataset.v, quantity: this.Q[this.i] || 1 }], root = window.Shopify?.routes?.root || '/';
      if (this.carte.dataset.kdo) items.push({ id: +this.carte.dataset.kdo, quantity: 1 });   // cadeau offert (e-book à 0 €) si le palier l'inclut
      const res = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items, sections: 'cart-drawer,cart-icon-bubble', sections_url: location.pathname }) });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Erreur');
      const d = document.querySelector('cart-drawer');
      if (d && typeof d.renderContents === 'function') { d.classList.remove('is-empty'); d.renderContents({ ...data, id: items[0].id }); }
      else location.href = `${root}cart`;
    } catch (e) { this.err.textContent = e.message; this.err.hidden = false; }
    finally { this.btn.classList.remove('is-load'); }
  }
}
if (!customElements.get('plf-offre')) customElements.define('plf-offre', PlfOffre);
